
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { I18nProvider } from "./i18n";
import VibeBeePublicPage from "./pages/VibeBeePublicPage";

function Root() {
  const pathname = typeof window !== "undefined" ? window.location.pathname : "/";

  if (pathname === "/vibebee") {
    return <VibeBeePublicPage />;
  }

  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <I18nProvider>
    <Root />
  </I18nProvider>
);

// PWA-lite: register only in production. The worker is intentionally limited
// to an offline fallback for safe public navigation and never caches /api,
// admin, owner, profile, preview, report, QR resolver, or Vibe Pass routes.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {
      // Registration failures are non-fatal; the website still works normally.
    });
  });
}
